<template>
  <div class="no-flow">
    <div class="welcome-border top"></div>
    <div class="movie">
      <video playsinline autoplay muted loop>
        <source src="../assets/images/welcome/welcome-mov.mov" type="video/mp4">
      </video>
    </div>
    <b-container id="welcome_to_interpretive_graphics">
      <b-row>
        <b-col md="10" offset-md="1" lg="8" offset-lg="2">
          <img alt="enviroSIGNS" src="../assets/images/enviroSIGNSlogo.png"/>
        </b-col>
      </b-row>
    </b-container>
    <div class="welcome-link bold-text"><router-link :to="{ name: 'home' }">Welcome / Enter Site</router-link></div>
    <div class="welcome-border bottom"></div>
  </div>
</template>

<script>
  export default {
    name: 'Welcome'
  }
</script>

<style lang="scss">
  @import '../assets/css/welcome.scss';
</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue